import { GlEmptyState } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'FilterEmptyState',
    components: {
        GlEmptyState
    }
};
